import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["canvas", "form", "input"];

  static values = {
    labels: Array,
    values: Array,
    editable: { type: Boolean, default: false },
  };

  async connect() {
    this.connected = true;

    const [{ Chart }, { default: DragDataPlugin }] = await Promise.all([
      import("../application/lib/charts"),
      import("chartjs-plugin-dragdata"),
    ]);

    if (!this.connected || this.chart) return;

    Chart.register(DragDataPlugin);

    this.Chart = Chart;
    this.renderChart();
  }

  disconnect() {
    this.connected = false;
    this.Chart = null;
    this.destroyChart();
  }

  renderChart() {
    if (!this.Chart || !this.hasCanvasTarget || !this.canvasTarget.isConnected)
      return;

    this.destroyChart();

    const context = this.canvasTarget.getContext("2d");
    if (!context) return;

    this.chart = new this.Chart(context, {
      type: "radar",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Score",
            data: this.valuesValue,
            backgroundColor: "rgba(102, 187, 106, 0.4)",
            borderColor: "rgba(102, 187, 106, 1)",
            borderWidth: 2,
            pointBackgroundColor: "#004d00",
            pointBorderColor: "#fff",
            pointRadius: 6,
            dragData: this.editableValue,
          },
        ],
      },
      options: {
        animation: false,
        scales: {
          r: {
            min: 0,
            max: 10,
            ticks: {
              stepSize: 1,
              backdropColor: "transparent",
            },
            grid: {
              color: "gray",
            },
            angleLines: {
              color: "gray",
            },
            pointLabels: {
              font: { size: 14 },
            },
          },
        },
        plugins: {
          legend: { display: false },
          dragData: {
            round: 0,
            showTooltip: true,
            onDrag: (_, __, index, value) => {
              if (!this.editableValue || value < 0 || value > 10) return false;

              this.syncInput(index, value);
            },
            onDragEnd: (_, __, index, value) => {
              if (!this.editableValue) return;

              this.syncInput(index, value);
              this.formTarget.requestSubmit();
            },
          },
        },
      },
    });
  }

  syncInput(index, value) {
    const input = this.inputTargets[index];
    if (!input) return;

    const roundedValue = Math.round(value);
    input.value = roundedValue;
  }

  destroyChart() {
    this.chart?.destroy();
    this.chart = null;
  }
}
